export default "__VITE_ASSET__Bf5nL4iM__"